import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg-dark flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10">
          <img src="/assets/logo.png" alt="US Desalination" className="h-16 w-auto brightness-0 invert" />
        </div>
        <div className="bg-white p-8 md:p-10">
          <h1 className="font-heading text-2xl text-ink tracking-tight">Admin Sign In</h1>
          <p className="text-ink-soft text-sm mt-1">Manage news & announcements.</p>
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
            <div>
              <label className="block text-ink-soft text-xs uppercase tracking-[0.15em] mb-2">Email</label>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-brand-navy/20 px-4 py-3 text-ink focus:border-brand-teal focus:outline-none"
                required
              />
            </div>
            <div>
              <label className="block text-ink-soft text-xs uppercase tracking-[0.15em] mb-2">Password</label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-brand-navy/20 px-4 py-3 text-ink focus:border-brand-teal focus:outline-none"
                required
              />
            </div>
            <button
              type="submit"
              data-testid="login-submit"
              disabled={loading}
              className="w-full bg-brand-navy text-white font-semibold py-3.5 hover:bg-brand-red transition-colors disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
